import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PredictionCreate = lazy(() =>
  import("@predictions/PredictionCreateNRO").then((module) => ({
    default: module.PredictionCreatePurchaseNRO,
  }))
);

export const engagementPredictionsNewPurchaseNRO: NavigationRoutingObject = {
  section: "analytics",
  Component: PredictionCreate,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("predictions-create-purchase-heading", "Create Event Prediction"),
  pageNameForTracking: () => "Create Event Prediction",
  getDeveloperNavigationAllowed: ({ predictionFeatures, hasPermission }) => {
    return (
      predictionFeatures.purchase.ENABLED &&
      hasPermission("appGroup", { permission: "viewPredictions" }) &&
      hasPermission("appGroup", { permission: "editPredictions" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/predictions/predictions/:appGroupId",
};
